<div class="history-dashboard">
  @if (isVisibleSig()) {
    <div #surfaceContainer class="history-dashboard__surface card">
      <div class="history-dashboard__toolbar-shell">
        <div class="history-dashboard__header-bar">
          <div class="history-dashboard__header-main">
            <button type="button" class="history-dashboard__back-button" (click)="goToMyReports()">
              <span class="history-dashboard__back-icon" aria-hidden="true">←</span>
              <span>My Reports</span>
            </button>

            <div class="history-dashboard__header-copy">
              <h2 class="history-dashboard__title" [title]="pageTitleSig()">{{ pageTitleSig() }}</h2>
              <div class="history-dashboard__toolbar-meta">
                <span class="history-dashboard__meta-pill history-dashboard__meta-pill--accent">
                  {{ scopeLabelSig() }} view
                </span>
                @if (asOfLabelSig(); as asOfLabel) {
                  <span class="history-dashboard__meta-pill">{{ asOfLabel }}</span>
                }
                <span class="history-dashboard__meta-pill">Historical trends</span>
              </div>
            </div>
          </div>

          @if (hasLoadedSig()) {
            <div class="history-dashboard__header-actions">
              @if (showMgaFilterSig()) {
                <ag-shr-report-entity-filter
                  class="history-dashboard__header-filter"
                  [options]="reportFilterOptionsSig()"
                  [value]="selectedReportFilterValuesSig()"
                  [disabled]="isLoadingSig()"
                  [placeholder]="reportFilterPlaceholderSig()"
                  [height]="34"
                  [maxDisplayedTags]="1"
                  (valueChange)="onReportFilterValueChanged($event)"
                ></ag-shr-report-entity-filter>
              }
              <div class="history-dashboard__horizon" role="group" aria-label="Production Horizon">
                <dx-button
                  class="history-dashboard__horizon-actual"
                  [class.history-dashboard__horizon-segment--active]="isActualHorizonSig()"
                  text="Actual Production"
                  type="normal"
                  stylingMode="outlined"
                  [disabled]="isLoadingSig()"
                  [elementAttr]="{ 'aria-pressed': isActualHorizonSig() }"
                  (onClick)="onActualHorizonClick()"
                ></dx-button>
                <dx-drop-down-button
                  class="history-dashboard__horizon-projection"
                  [class.history-dashboard__horizon-segment--active]="isProjectionHorizonSig()"
                  [text]="projectionHorizonLabelSig()"
                  type="normal"
                  stylingMode="outlined"
                  [splitButton]="true"
                  [useSelectMode]="false"
                  [items]="projectionModelItems"
                  displayExpr="text"
                  keyExpr="id"
                  itemTemplate="projectionModelItem"
                  [selectedItemKey]="selectedProjectionMethodSig()"
                  [disabled]="isLoadingSig() || !isProjectionAvailableSig()"
                  [hint]="
                    isProjectionAvailableSig()
                      ? ''
                      : 'Projection is unavailable when there is no current-year production'
                  "
                  [dropDownOptions]="horizonDropDownOptions"
                  [elementAttr]="{ 'aria-label': 'Projection model' }"
                  (onButtonClick)="onProjectionHorizonClick()"
                  (onItemClick)="onProjectionModelClick($event)"
                  (onClosed)="closeProjectionHelpNow()"
                >
                  <div *dxTemplate="let item of 'projectionModelItem'">
                    <div
                      class="history-dashboard__projection-model-item"
                      (mouseenter)="openProjectionHelp($event, item)"
                      (mouseleave)="closeProjectionHelp()"
                    >
                      {{ item.text }}
                    </div>
                  </div>
                </dx-drop-down-button>
              </div>
              <dx-drop-down-button
                class="history-dashboard__years-button"
                hint="Select years"
                icon="event"
                type="normal"
                stylingMode="outlined"
                dropDownContentTemplate="yearsContent"
                [showArrowIcon]="false"
                [height]="34"
                [disabled]="isLoadingSig()"
                [dropDownOptions]="yearsDropDownOptions"
              >
                <div *dxTemplate="let data of 'yearsContent'">
                  <dx-list
                    [dataSource]="selectableYearsSig()"
                    [selectedItemKeys]="selectedYearsSig()"
                    [selectionMode]="'all'"
                    [selectAllMode]="'allPages'"
                    [showSelectionControls]="true"
                    [searchEnabled]="false"
                    [height]="260"
                    (onSelectionChanged)="onYearListSelectionChanged($event)"
                  >
                    <div *dxTemplate="let year of 'item'">{{ year }}</div>
                  </dx-list>
                </div>
              </dx-drop-down-button>
              <dx-drop-down-button
                class="history-dashboard__download-button"
                hint="Download"
                icon="download"
                type="normal"
                stylingMode="outlined"
                [showArrowIcon]="false"
                [items]="exportMenuItems"
                displayExpr="text"
                keyExpr="id"
                [height]="34"
                [disabled]="isLoadingSig() || isExportingSig()"
                [dropDownOptions]="{ width: 150 }"
                (onItemClick)="onExportItemClick($event)"
              ></dx-drop-down-button>
              <dx-button
                hint="Fullscreen"
                type="normal"
                stylingMode="outlined"
                icon="agi-up-right-and-down-left-from-center"
                [height]="34"
                [disabled]="isLoadingSig()"
                (onClick)="toggleFullScreen(surfaceContainer)"
              ></dx-button>
            </div>
          }
        </div>
      </div>

      <!-- Kept outside header-actions: a visible overlay host must never take width from the toolbar controls. -->
      <dx-popover
        [(visible)]="isProjectionHelpVisible"
        [target]="projectionHelpTarget"
        [hideOnOutsideClick]="false"
        [width]="430"
        position="left"
      >
        <div *dxTemplate="let data of 'content'">
          @if (projectionHelpOption; as option) {
            <div (mouseenter)="holdProjectionHelp()" (mouseleave)="closeProjectionHelp()">
              <ag-shr-projection-method-help [option]="option" />
            </div>
          }
        </div>
      </dx-popover>

      <div class="history-dashboard__content">
        <div class="history-dashboard__body">
          @if (unavailableReasonSig(); as unavailableReason) {
            <ag-shr-report-unavailable
              [reason]="unavailableReason"
              [scope]="currentScopeSig()"
            ></ag-shr-report-unavailable>
          } @else {
            @if (loadErrorMessageSig()) {
              <div class="alert alert-danger" role="alert">
                {{ loadErrorMessageSig() }}
              </div>
            }

            @if (!isLoadingSig()) {
              @for (section of historySections; track section.id) {
                <section class="history-dashboard__section">
                  <article class="history-dashboard__grid-card">
                    <div class="history-dashboard__grid-card-header">
                      <h4 class="history-dashboard__grid-card-title">{{ getSectionTitle(section.id) }}</h4>
                    </div>

                    <div #gridShell class="history-dashboard__grid-shell">
                      <dx-data-grid
                        class="history-dashboard__grid"
                        [dataSource]="getGridRows(section.id)"
                        [showBorders]="false"
                        [rowAlternationEnabled]="true"
                        [columns]="getGridColumns(section.id, gridShell)"
                        [columnAutoWidth]="false"
                        [columnMinWidth]="150"
                        [allowColumnResizing]="true"
                        columnResizingMode="widget"
                        [hoverStateEnabled]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [wordWrapEnabled]="true"
                        [height]="'auto'"
                      >
                        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                        <dxo-scrolling
                          mode="standard"
                          columnRenderingMode="standard"
                          showScrollbar="always"
                          [useNative]="true"
                        ></dxo-scrolling>
                        <dxo-sorting mode="none"></dxo-sorting>
                        <dxo-paging [enabled]="false"></dxo-paging>
                        <div *dxTemplate="let cellInfo of 'monthlyProductionCellTemplate'">
                          <div
                            [class]="getMonthlyProductionCellClass(cellInfo)"
                            [class.history-dashboard__top-cell]="isGlobalTopProducingMonthCell(cellInfo)"
                            [attr.title]="
                              getProjectionCellTitle(cellInfo) ??
                              (isGlobalTopProducingMonthCell(cellInfo)
                                ? 'Top producing month across displayed years'
                                : null)
                            "
                          >
                            <span class="history-dashboard__monthly-cell-value">
                              @if (cellInfo.value !== null && cellInfo.value !== undefined) {
                                {{ cellInfo.value | currency: "USD" : "symbol" : "1.2-2" }}
                              }
                            </span>
                          </div>
                        </div>
                        <div *dxTemplate="let cellInfo of 'quarterlyProductionCellTemplate'">
                          <div
                            [class]="getQuarterlyProductionCellClass(cellInfo)"
                            [class.history-dashboard__top-cell]="isGlobalTopProducingQuarterCell(cellInfo)"
                            [attr.title]="
                              getProjectionCellTitle(cellInfo) ??
                              (isGlobalTopProducingQuarterCell(cellInfo)
                                ? 'Top producing quarter across displayed years'
                                : null)
                            "
                          >
                            <span class="history-dashboard__quarterly-cell-value">
                              @if (cellInfo.value !== null && cellInfo.value !== undefined) {
                                {{ cellInfo.value | currency: "USD" : "symbol" : "1.2-2" }}
                              }
                            </span>
                          </div>
                        </div>
                        <div *dxTemplate="let cellInfo of 'annualValueCellTemplate'">
                          <div [class]="getAnnualCellClass(cellInfo)" [attr.title]="getProjectionCellTitle(cellInfo)">
                            @if (cellInfo.value !== null && cellInfo.value !== undefined) {
                              @if (isAnnualPercentCell(cellInfo)) {
                                {{ cellInfo.value | percent: "1.1-1" }}
                              } @else {
                                {{ cellInfo.value | currency: "USD" : "symbol" : "1.2-2" }}
                              }
                            }
                          </div>
                        </div>
                        <div *dxTemplate="let cellInfo of 'comparisonPercentCellTemplate'">
                          <div
                            [class]="getComparisonPercentCellClass(cellInfo)"
                            [attr.title]="getProjectionCellTitle(cellInfo)"
                          >
                            @if (cellInfo.value !== null && cellInfo.value !== undefined) {
                              {{ cellInfo.value | percent: "1.1-1" }}
                            }
                          </div>
                        </div>
                        @if (getGridSummaryItems(section.id).length) {
                          <dxo-summary [calculateCustomSummary]="calculateGridSummary(section.id)">
                            @for (summaryItem of getGridSummaryItems(section.id); track summaryItem.name) {
                              <dxi-total-item
                                [name]="summaryItem.name"
                                summaryType="custom"
                                [column]="summaryItem.column"
                                [valueFormat]="summaryItem.valueFormat"
                              ></dxi-total-item>
                            }
                          </dxo-summary>
                        }
                      </dx-data-grid>
                    </div>

                    @if (getTableFootnote(section.id); as footnote) {
                      <p class="history-dashboard__grid-footnote">{{ footnote }}</p>
                    }
                  </article>
                </section>
              }
            }
          }
        </div>
      </div>

      <dx-load-panel
        [container]="surfaceContainer"
        [position]="{ my: 'center', at: 'center', of: surfaceContainer }"
        [visible]="isLoadingSig()"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        shadingColor="rgba(255,255,255,0.7)"
      ></dx-load-panel>
    </div>
  } @else if (isAccessKnownSig()) {
    <div class="history-dashboard__surface card">
      <div class="history-dashboard__toolbar-shell">
        <div class="history-dashboard__header-bar">
          <div class="history-dashboard__header-main">
            <button type="button" class="history-dashboard__back-button" (click)="goToMyReports()">
              <span class="history-dashboard__back-icon" aria-hidden="true">←</span>
              <span>My Reports</span>
            </button>
          </div>
        </div>
      </div>
      <ag-shr-report-unavailable reason="no-access" [scope]="currentScopeSig()"></ag-shr-report-unavailable>
    </div>
  }
</div>
